module.exports = __webpack_public_path__ + "static/media/logo.33aff0b4.svg";